import { render, staticRenderFns } from "./Materia.vue?vue&type=template&id=11f4bf8e&scoped=true&"
import script from "./Materia.vue?vue&type=script&lang=js&"
export * from "./Materia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f4bf8e",
  null
  
)

export default component.exports